module.exports = __webpack_public_path__ + "img/water-quality.84a05cbc.svg";